var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{attrs:{"size":"20","color":"var(--v-resGrey-lighten1)"}},[_c('v-icon',{attrs:{"dense":"","color":"var(--v-resGrey-darken1)"}},[_vm._v(" mdi-approximately-equal ")])],1),_c('span',[_vm._v(_vm._s(_vm.params.contents))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }